import React, { useState } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, Space } from 'antd';
import { 
  UserOutlined, 
  LogoutOutlined, 
  DashboardOutlined, 
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  TeamOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/sidebar.css';

const { Sider } = Layout;

const Sidebar = ({ user, onLogout, profile }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = ({ key }) => {
    if (key === 'dashboard') {
      navigate('/');
    } else
    if (key === 'clients') {
      navigate('/clients');
    } else if (key === 'users') {
      navigate('/users');
    } else if (key === 'settings') {
      navigate('/settings');
    }
  };

  const getSelectedKeys = () => {
    const path = location.pathname;
    if (path === '/') return ['dashboard'];
    if (path === '/clients') return ['clients'];
    if (path === '/users') return ['users'];
    if (path === '/settings') return ['settings'];
    return ['dashboard'];
  };

  const menuItems = [
    // {
    //   key: 'dashboard',
    //   icon: <DashboardOutlined />,
    //   label: 'Dashboard',
    // },
    {
      key: 'clients',
      icon: <TeamOutlined />,
      label: 'Clients',
    },
    // {
    //   key: 'users',
    //   icon: <UserOutlined />,
    //   label: 'Users',
    // },
    // {
    //   key: 'settings',
    //   icon: <SettingOutlined />,
    //   label: 'Settings',
    // },
  ];

  const userMenu = (
    <Menu>
      {/* <Menu.Item key="profile" icon={<UserOutlined />}>
        Profile
      </Menu.Item>
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        Settings
      </Menu.Item> */}
      {/* <Menu.Divider /> */}
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={onLogout}>
        Sign Out
      </Menu.Item>
    </Menu>
  );

  return (
    <Sider 
      width={200} 
      collapsedWidth={80}
      style={{ 
        background: '#fff',
        position: 'relative',
        height: '100vh',
        boxShadow: '2px 0 8px rgba(0,0,0,0.1)'
      }}
      collapsed={collapsed}
      collapsible={false}
    >
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%',
        position: 'relative'
      }}>
        {/* Logo/Brand Section */}
        <div 
          className={`sidebar-brand ${collapsed ? 'collapsed' : ''}`}
          style={{ 
            padding: '16px', 
            textAlign: 'center',
            borderBottom: '1px solid #f0f0f0',
            minHeight: '64px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {!collapsed ? (
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
              Admin Panel
            </div>
          ) : (
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              AP
            </div>
          )}
        </div>

        {/* Navigation Menu */}
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <Menu
            mode="inline"
            selectedKeys={getSelectedKeys()}
            style={{ 
              height: '100%', 
              borderRight: 0,
              borderBottom: '1px solid #f0f0f0'
            }}
            items={menuItems}
            onClick={handleMenuClick}
          />
        </div>

        {/* User Profile Section */}
        <div 
          className={`sidebar-user-profile ${collapsed ? 'collapsed' : ''}`}
          style={{ 
            borderTop: '1px solid #f0f0f0',
            background: '#fafafa'
          }}
        >
          <Dropdown overlay={userMenu} placement="topRight" trigger={['click']}>
            <Space style={{ cursor: 'pointer', width: '100%', justifyContent: collapsed ? 'center' : 'flex-start' }}>
              <Avatar icon={<UserOutlined />} size={collapsed ? 'default' : 'small'} />
              {!collapsed && (
                <span style={{ fontSize: '14px' }}>
                  {profile?.email || 'User'}
                </span>
              )}
            </Space>
          </Dropdown>
        </div>

        {/* Collapse/Expand Button */}
        <div style={{ 
          padding: '8px',
          borderTop: '1px solid #f0f0f0',
          textAlign: 'center'
        }}>
          <Button
            className={`sidebar-collapse-btn ${collapsed ? 'collapsed' : 'expanded'}`}
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            title={collapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
          />
        </div>
      </div>
    </Sider>
  );
};

export default Sidebar;
